import styled from 'styled-components';

import { spacing } from '@savgroup-front-common/primitive/helpers/spacing';

import { Link } from '../../link';
import { Tooltip } from '../../Tooltip';
import { buttonStyleMixin } from '../Button.styles';

import { InnerButtonLinkStyledProps } from './ButtonLink.types';

export const $InnerLinkStyled = styled(Link)<InnerButtonLinkStyledProps>`
  ${buttonStyleMixin};
  &,
  &:hover {
    text-decoration: none;
  }
`;

export const $LockedTooltip = styled(Tooltip)`
  display: flex !important;
  align-items: center;
  justify-content: space-between;
  gap: ${spacing('sm')};
`;
